import { render } from "./Device.vue?vue&type=template&id=2f0e985c&ts=true"
import script from "./Device.vue?vue&type=script&lang=ts"
export * from "./Device.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__